import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderIcon } from '@core/services/page-title.service';

@Component({
  selector: 'app-page-header-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg class="block" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <ng-container [ngSwitch]="icon">
        <ng-container *ngSwitchCase="'dashboard'">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </ng-container>
        <ng-container *ngSwitchCase="'documents'">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </ng-container>
        <ng-container *ngSwitchCase="'activity'">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </ng-container>
        <ng-container *ngSwitchCase="'playground'">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </ng-container>
        <ng-container *ngSwitchCase="'template'">
          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
          <polyline points="13 2 13 9 20 9"></polyline>
        </ng-container>
        <ng-container *ngSwitchCase="'key'">
          <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'webhook'">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
        </ng-container>
        <ng-container *ngSwitchCase="'analytics'">
          <line x1="12" y1="20" x2="12" y2="10"></line>
          <line x1="18" y1="20" x2="18" y2="4"></line>
          <line x1="6" y1="20" x2="6" y2="16"></line>
        </ng-container>
        <ng-container *ngSwitchCase="'report'">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
        </ng-container>
        <ng-container *ngSwitchCase="'billing'">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
          <line x1="1" y1="10" x2="23" y2="10"></line>
        </ng-container>
        <ng-container *ngSwitchCase="'settings'">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'support'">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'help'">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </ng-container>
        <ng-container *ngSwitchCase="'business'">
          <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'admin'">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <circle cx="12" cy="12" r="9"></circle>
        </ng-container>
      </ng-container>
    </svg>
  `
})
export class PageHeaderIconComponent {
  @Input({ required: true }) icon!: PageHeaderIcon;
}
